import { useState } from "react";

import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";
import PageHeader from "@/components/UI/PageHeader";
import { TabsSwitcher } from "@/components/UI/TabsSwitcher";

type ActivityDatasetTab = {
  key: string;
  label: string;
  datasetType: string;
  endpointPrefix: string;
};

const IAM_LOGIN_HISTORY_ENDPOINT_PREFIX = `${import.meta.env.VITE_IAM_URL}/manage/login-history`;

const ACTIVITY_DATASET_TABS: ActivityDatasetTab[] = [
  {
    key: "askvivo_questions",
    label: "Ask Vivo Usage",
    datasetType: "askvivo_questions",
    endpointPrefix: "usage-monitoring",
  },
  {
    key: "user_logins",
    label: "User Logins",
    datasetType: "login_history",
    endpointPrefix: IAM_LOGIN_HISTORY_ENDPOINT_PREFIX,
  },
  {
    key: "page_views",
    label: "Page Views",
    datasetType: "page_views",
    endpointPrefix: "usage-monitoring",
  },
];

const DASHBOARD_CONSTANTS = {
  wikiLink: "/wiki/guides/admin-activity-log",
  idLink: undefined,
};

const buildAdminUsageRowKey = (record: Record<string, unknown>) =>
  [
    record.timestamp,
    record.user_email,
    record.question,
    record.page,
    record.status,
  ]
    .filter(Boolean)
    .join("-");

export default function AdminActivityLogPage() {
  const [activeTab, setActiveTab] = useState<ActivityDatasetTab>(
    ACTIVITY_DATASET_TABS[0],
  );

  return (
    <div className="w-full p-4">
      <div className="mb-4 flex justify-between gap-4">
        <PageHeader
          title="Admin: Vivo Usage"
          tooltipText="Review Ask Vivo and admin activity events across the current tenant workspace."
          dataTestId="admin-activity-log-page-header-info-tooltip"
        />
        <div className="flex items-center">
          <TabsSwitcher
            tabItems={ACTIVITY_DATASET_TABS}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>
      </div>

      <MetadataDashboardTemplate
        type={activeTab.datasetType}
        constants={DASHBOARD_CONSTANTS}
        endpointPrefix={activeTab.endpointPrefix}
        selectionIdentifierColumn="user_email"
        rowKey={buildAdminUsageRowKey}
      />
    </div>
  );
}
